import { render, staticRenderFns } from "./CalendarControlWaitingRoom.vue?vue&type=template&id=2a7e4f5e&scoped=true"
import script from "./CalendarControlWaitingRoom.vue?vue&type=script&lang=js"
export * from "./CalendarControlWaitingRoom.vue?vue&type=script&lang=js"
import style0 from "./CalendarControlWaitingRoom.vue?vue&type=style&index=0&id=2a7e4f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7e4f5e",
  null
  
)

export default component.exports